import { z } from 'zod';
import { BrandCornerBannerDTO } from './brandCornerBanner';
import { MarketingBannerDTO } from './marketingBanner';
import { PromoBannerDTO } from './promoBanner';

export const ProductDetailBannerDTO = z.union([PromoBannerDTO, MarketingBannerDTO, BrandCornerBannerDTO]);

export type ProductDetailBannerDTO = z.infer<typeof ProductDetailBannerDTO>;

export const ProductDetailBannersDTO = z.array(ProductDetailBannerDTO);
export type ProductDetailBannersDTO = z.infer<typeof ProductDetailBannersDTO>;
